import * as types from '@/store/types'
export default {
    modules: state => {
        return state.modules
    },
    modelDefault: state => {
        return state.modelDefault
    },
    moduleMethods: state => {
        return state.moduleMethods
    },
    getModuleById: state => id => {
        return state.modules.find(module => module.id === id)
    },
    getTitleMethodById: state => id => {
        let result = state.moduleMethods['main'] !== undefined
            ? state.moduleMethods['main'].find(module => module.id === id)
            : undefined
        if (result === undefined) {
            return ''
        } else {
            return result.title
        }
    },
    getModuleMethodsLoadedValue: state => {
        return state.moduleMethodsLoaded
    }
}
